import React from "react";

import "./ui.css";

const toneAliases = {
  active: "success",
  approved: "success",
  completed: "success",
  enabled: "success",
  success: "success",
  cancelled: "danger",
  disabled: "danger",
  error: "danger",
  failed: "danger",
  danger: "danger",
  paused: "warning",
  pending: "warning",
  warning: "warning",
  new: "info",
  processing: "info",
  running: "info",
  info: "info",
  neutral: "neutral",
};

const formatStatus = (status) => {
  if (!status) return "Status";

  const value = String(status).replace(/[_-]+/g, " ").trim();
  return value.charAt(0).toUpperCase() + value.slice(1);
};

/** Maps common application statuses to a consistent, accessible badge. */
const StatusBadge = ({
  status = "neutral",
  tone,
  label,
  children,
  icon,
  showDot = true,
  size = "medium",
  className = "",
  ariaLabel,
}) => {
  const normalizedStatus = String(status).toLowerCase();
  const normalizedTone = toneAliases[String(tone || normalizedStatus).toLowerCase()] || "neutral";
  const normalizedSize = size === "small" ? "small" : "medium";
  const content = children ?? label ?? formatStatus(status);
  const classes = [
    "rg-ui-status-badge",
    `rg-ui-status-badge--${normalizedTone}`,
    `rg-ui-status-badge--${normalizedSize}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <span className={classes} aria-label={ariaLabel}>
      {icon ? (
        <span className="rg-ui-status-badge__icon" aria-hidden="true">
          {icon}
        </span>
      ) : (
        showDot && <span className="rg-ui-status-badge__dot" aria-hidden="true" />
      )}
      <span>{content}</span>
    </span>
  );
};

export default StatusBadge;
